import { render } from "./TreeVineSpacingChart.vue?vue&type=template&id=faf93788&scoped=true"
import script from "./TreeVineSpacingChart.vue?vue&type=script&lang=js"
export * from "./TreeVineSpacingChart.vue?vue&type=script&lang=js"

import "./TreeVineSpacingChart.vue?vue&type=style&index=0&id=faf93788&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faf93788"]])

export default __exports__